module.exports = __webpack_public_path__ + "img/rw.6868a09c.svg";